<template>
  <vbt-dialog
    v-model="dialog"
    :title="title"
    width="700px"
    submit-btn-name="Change"
    @submit="submitForm"
    @close="$_resetFormAndValidation"
  >
    <v-form
      :ref="formRef"
      @submit.prevent="submitForm"
    >
      <ums-password-field v-model="form.password" />
    </v-form>
  </vbt-dialog>
</template>

<script>
import { useDialog, useFormWithRef } from '@mixins/factories';

import { wrapToLoadingFn } from '@helpers';

import ApplicationsApiService from '../_services/applications.api.service';

export default {
  name: 'UmsApplicationPasswordChanger',
  props: {
    app: {
      type: String,
      default: '',
    },
  },
  mixins: [
    useDialog(),
    useFormWithRef(),
  ],
  data: () => ({
    form: { password: '' },
  }),
  computed: {
    title() {
      return `Change password for application ${this.app}`;
    },
  },
  methods: {
    wrapToLoadingFn,
    submitForm() {
      if (!this.$_validateForm()) {
        return;
      }

      this.$VBlackerTheme.alert.warning({
        text: 'Change password?',
      }, () => this.wrapToLoadingFn({
        req: ApplicationsApiService.changeApplicationPassword.bind({}, {
          name: this.app,
          password: this.form.password,
        }),
        onSuccess: () => {
          this.$VBlackerTheme.notification.success('Password successfully changed');
          this.$emit('success');
          this.$_closeDialog();
        },
      }));
    },
  },
};
</script>
